import none from '../../img/kandokLogo.jpg'
export const irani =[
 {
  "id": 21,
  "title": "باقالی پلو با گردن گوسفندی",
  "desciption": "500گرم گردن گوسفندی، 300گرم برنج",
  "price": 600,
  "image": none
 },
 {
  "id": 22,
  "title": "باقالی پلو با گوشت سردست گوسفندی",
  "desciption": "400گرم گوشت سردست گوسفندی، 300گرم برنج",
  "price": 500,
  "image": none
 },
 {
  "id": 23,
  "title": "دیزی با گوشت گردن گوسفندی",
  "desciption": "150گرم گوشت کردن گوسفند، حبوبات و مخلفات، یک کاسه ترشی",
  "price": 220,
  "image": none
 },
 {
  "id": 24,
  "title": "چلو ماهی قزل آا",
  "desciption": "یک عدد ماهی کامل قزل آلا طعم دار شده سرخ شده، 300گرم برنج",
  "price": 250,
  "image": none
 },
 {
  "id": 25,
  "title": "باقالی پلو با مرغ",
  "desciption": "ران یا سینه 400 گرمی، 300گرم برنج",
  "price": 185,
  "image": none
 },
 {
  "id": 26,
  "title": "زرشک پلو با مرغ",
  "desciption": "ران یا سینه 400گرمی، نثار زعفرانی زرشک، 300گرم برنج",
  "price": 170,
  "image": none
 },
 {
  "id": 27,
  "title": "چلو خورشت قیمه بادمجان",
  "desciption": "300گرم خوشت قیمه با گوشت گوساله، دو عدد بادمجان، 300گرم برنج",
  "price": 150,
  "image": none
 },
 {
  "id": 28,
  "title": "چلو خورشت قیمه سیب زمینی",
  "desciption": "300گرم خوشت قیمه با گوشت گوساله، سیب زمینی سرخ شده، 300گرم برنج",
  "price": 145,
  "image": none
 },
 {
  "id": 29,
  "title": "چلو خورشت قورمه سبز",
  "desciption": "300گرم خورشت قورمه سبزیبا گوشت گوساله، 300گرم برنج",
  "price": 145,
  "image": none
 },
 {
  "id": 210,
  "title": "چلو کره",
  "desciption": "300گرم برنج بهه همراه کره 20 گرمی",
  "price": 55,
  "image": none
 },
 {
  "id": 211,
  "title": "کته زعفرانی",
  "desciption": "300گرم برنج پخته شده ببه صورت ته‌دیگی زعفرانی و کته به همراه کره 25گرمی",
  "price": 65,
  "image": none
 },
 {
  "id": 212,
  "title": "باقالی پلو",
  "desciption": "300 گرم برنج با باقالی و شوید به همراه کره 25 گرمی",
  "price": 70,
  "image": none
 },
 {
  "id": 213,
  "title": "کته باقالی",
  "desciption": "300 گرم برنج با باقالی و شوید، پختته شده به صورت ته‌دیگی و کته به همراه کرهه 25 گرمی",
  "price": 80,
  "image": none
 }
]